import request from "@/utils/pictureRequest";

//图书馆-获取图书列表V3
export const getLibraryBookListV3 = (params) => {
  return request.get(`/library/books/listV3`, "nocache", {
    params: params,
  });
};

//图书馆-难度等级
export function getLibraryBookDifficultyLevel(params) {
  return request.get(`/library/books/getDifficultyLevel`, "nocache", {
    params: params,
  });
}

//动画-获取动画列表
export function getCartoonVideoList(params) {
  return request.get(`/cartoon/video/getVideosV2`, "nocache", {
    params: params,
  });
}

//音频级别
export function getAudioCategoryList(params) {
  return request.get(`/Audio/Index/categoryList`, "nocache", {
    params: params,
  });
}

//音频列表
export function getAudioList(params) {
  return request.get(`/Audio/Index/index`, "nocache", {
    params: params,
  });
}

//图书过滤
export function getBookFilterCondition(params) {
  return request.get(`/library/books/filterCondition`, "nocache", {
    params: params,
  });
}
